/* eslint-disable react/prop-types */
import React from 'react';
import { format } from 'date-fns';
import * as styles from '../../styles/date-selector';
import { jsx as ___EmotionJSX } from "@emotion/core";
var DateSelector = _ref => {
  var selectedDate = _ref.selectedDate;
  var label = format(new Date(selectedDate), 'DD/MM/YYYY');
  return ___EmotionJSX("button", {
    css: styles.dateSelectorButton,
    type: "button"
  }, label);
};
export default DateSelector;